import template   from './my-profile.html'
import controller from './my-profile.controller'

let component = {
  restrict: 'E',
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/registration/my-profile/my-profile.component.js